var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 121,
    viewBox: "0 0 142 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vectors/Upload Image",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.6036 69.3436C99.7231 69.3436 102.975 66.1154 102.975 62.0255C102.975 57.9357 99.7231 54.7075 95.6036 54.7075C91.4841 54.7075 88.2324 57.9357 88.2324 62.0255C88.2324 65.8998 91.4851 69.3436 95.6036 69.3436ZM95.6036 57.7211C97.9882 57.7211 99.7231 59.6582 99.7231 61.8109C99.7231 64.1784 97.7719 65.9008 95.6036 65.9008C93.2189 65.9008 91.4841 63.9637 91.4841 61.8109C91.485 59.6582 93.2189 57.7211 95.6036 57.7211Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M121.188 99.9071L123.573 102.275L127.258 98.4004V107.656H130.51V98.4004L134.412 102.275L136.797 99.9071L128.992 92.3745L121.188 99.9071Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M127.256 117.342H130.507V120.57H127.256V117.342Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M127.256 110.884H130.507V114.112H127.256V110.884Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.873 87.4257L16.0414 89.7932L19.9438 85.9189V95.1741H23.1954V85.9189L27.0978 89.7932L29.2662 87.4257L21.4615 79.8921L13.873 87.4257Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.9453 98.4004H23.1969V101.629H19.9453V98.4004Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.9453 104.858H23.1969V108.087H19.9453V104.858Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.2324 108.086L59.6171 110.454L62.6523 107.44V114.974H65.9039V107.44L68.9391 110.454L71.1075 108.086L64.17 101.199L57.2324 108.086Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M62.6523 117.772H65.904V121H62.6523V117.772Z",
    fill: "#254167",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M142 44.594C142 27.3757 127.908 13.1689 110.347 13.1689C108.396 13.1689 105.36 13.5992 103.409 14.0296C99.724 0.685595 87.1503 -9 73.0595 -9C59.4015 -9 47.4783 -0.175291 43.1426 12.5227C40.9742 11.8766 38.8069 11.4463 36.6383 11.4463C20.3784 11.4463 16.9106 25.6519 16.2599 29.9566C6.72143 32.5397 0 41.1489 0 51.049C0 63.102 9.7559 72.7875 21.8963 72.7875C24.7143 72.7875 27.3163 72.3572 29.9172 71.2808C32.3018 73.864 35.5533 75.8011 39.2395 76.6617V96.4631H114.685V75.5855C130.077 73.4337 142 60.0898 142 44.5926L142 44.594ZM28.6157 62.8884L25.5805 63.7491C26.014 65.4706 26.8809 66.9773 27.7489 68.484C25.7977 69.13 23.8465 69.3447 21.8953 69.3447C11.7061 69.3447 3.25067 60.9502 3.25067 50.8344C3.25067 42.0097 9.53753 34.4768 18.2091 32.7546L19.5096 32.5389V31.2478C19.5096 30.6018 20.81 14.6746 36.8528 14.6746C38.8039 14.6746 40.7551 15.105 42.4889 15.5353C42.0554 17.6881 41.8382 20.0556 41.8382 22.2073H45.0898C45.0898 19.8399 45.3071 17.2569 45.9568 14.8893C49.2084 2.6208 60.4819 -5.98832 73.2718 -5.98832C86.4965 -5.98832 97.9861 3.26684 100.803 15.9648L101.237 17.4715L102.754 17.0411C102.754 17.0411 107.957 15.9648 110.559 15.9648C126.168 15.9648 138.959 28.6637 138.959 44.1597C138.959 57.9341 128.552 69.7714 114.895 71.9249L114.896 45.6686H39.0179V73.2189C34.0315 71.7122 30.1291 68.0536 28.6115 62.8883L28.6157 62.8884ZM111.215 83.3348L103.844 75.8022L96.2565 83.5507L77.1785 64.6102L66.3386 77.3091L58.7513 69.5607L42.4914 85.9183V48.8997H111.432L111.433 83.3351L111.215 83.3348ZM42.2745 93.236V90.6529L58.5344 74.2953L66.3391 82.0438L77.179 69.3448L96.0398 88.2853L103.627 80.5368L110.998 88.0695V93.2348L42.2745 93.236Z",
    fill: "#254167",
    fillOpacity: 0.45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/drag_drop.dfc3cfff3e7ba85da60040fcac505d30.svg";
export { ForwardRef as ReactComponent };